import enGb from '@i18n/locales-compiled/en-GB.json'
import enUs from '@i18n/locales-compiled/en-US.json'
import enUsOverrides from '@i18n/locales-override/en-US.json'
import enGbOverrides from '@i18n/locales-override/en-GB.json'
import { assertUnreachable } from '@gaia-family/lib'
import { SupportedUtsLocales } from '@gaia-family/i18n'

export const getLocalisedDictionary = (locale: SupportedUtsLocales) => {
  switch (locale) {
    case SupportedUtsLocales.enGB:
      return Object.assign(enGb, enGbOverrides, {})
    case SupportedUtsLocales.enUS:
      return Object.assign(enUs, enUsOverrides, {})
    default:
      assertUnreachable(locale)
  }
}
